import React, {  useEffect} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
//import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { Button } from '@mui/material';
import { Link,useNavigate } from "react-router-dom";
import AxiosFetchData from '../pages/AxiosFetchData';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

export default function ConfirmationButton({children, classname, onClick=null, title=null,text,type = null ,formid=null, id=null,disabled=false}) {
  const [open, setOpen] = React.useState(false);
  let btnRef;
  const handleClickOpen = (event) => {
    event.preventDefault();
    var form = document.getElementById(formid)
    if(type == 'submit'){
        if(form.checkValidity()){
            setOpen(true);
         }else{
            document.getElementById(id).click();
         }
         return;
    }
    setOpen(true);
   
  };
 
  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () =>{
    
    document.getElementById(id).click();
    setOpen(false);
  }

  function handleOnClick(){
     onClick();
    setOpen(false);
  }

  return (
    <div>
         <button style={{display:"none"}} id={id} type="submit" >{children}</button>
         <button onClick={handleClickOpen} className={classname} title={title} disabled={disabled}>{children}</button> 

         <Dialog
           open={open}
           onClose={handleClose}
           fullWidth
           maxWidth="xs"
        >
           <DialogTitle id="alert-dialog-title">
             {text}
           </DialogTitle>
           {/* <DialogContent>
              <DialogContentText id="alert-dialog-description">
               Do you want save this data?
            </DialogContentText>
            </DialogContent> */}
            <DialogActions>
             
              <button onClick={handleClose} className='btn btn-danger btn-sm'>Close</button>
             
              {type == 'button' ? (
                <button type={type} onClick={handleOnClick} className='btn btn-success btn-sm'>{children}</button>
               ) : (
                <button className='btn btn-success btn-sm' onClick={handleSubmit}>{children}</button>
                // <Button  variant="contained" type="submit">{children}</Button>
              )}
            </DialogActions>
         </Dialog>
       
    </div>
  );
}